import { Redirect } from "react-router-dom";

import { FullscreenLoading } from "../../components/FullscreenLoading";
import { getStoredSessionRedirectPath } from "../../utils/authentication";

// A component used to redirect user to the right home page according to its
// profile
export const LoginRedirect = () => {
  return (
    <>
      <FullscreenLoading isVisible />
      <Redirect to={getStoredSessionRedirectPath() || "/login"} />
    </>
  );
};
